<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-header-left>
    <h2 class="title">Bulk Clearwater Transactions</h2>
  </nf-grid-wrapper-header-left>
  <!-- <ng-grid-wrapper-header-right>
    <hs-upload-transactions-file></hs-upload-transactions-file>
  </ng-grid-wrapper-header-right> -->
  <ng-grid-wrapper-header-right class="createbulk">
    <div ngbDropdown placement="bottom-right">
      <button
        [disabled]="!hasPermissionForBulkActions"
        nf-button="create"
        id="dropdown3"
        ngbDropdownToggle
      >
        Bulk Create
      </button>
      <div
        ngbDropdownMenu
        aria-labelledby="dropdown3"
        class="dropdown-menu dropdown-menu-right"
      >
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="createBulkActionButton('Cash Entry')"
        >
          Cash Entry
        </button>
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="createBulkActionButton('Trade')"
        >
          Trade
        </button>
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="createBulkActionButton('Direct Transfer')"
        >
          Direct Transfer
        </button>
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="createBulkActionButton('Currency Forward')"
        >
          Currency Forward
        </button>
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="createBulkActionButton('Fx Spot')"
        >
          Fx Spot Trade
        </button>
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="createBulkActionButton('Wire Transfer')"
        >
          Wire Transfer
        </button>
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="createBulkActionButton('Security Transfer In')"
        >
          Security Transfer In
        </button>
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="createBulkActionButton('Security Transfer Out')"
        >
          Security Transfer Out
        </button>
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="createBulkActionButton('Security Exchange')"
        >
          Security Exchange
        </button>
      </div>
    </div>
  </ng-grid-wrapper-header-right>

  <ng-grid-wrapper-header-right class="createbulk">
    <button
      #searchPopoverComponent="ngbPopover"
      nf-button="primary"
      ngbTooltip="Search for Clearwater Transactions to Download"
      placement="auto"
      [ngbPopover]="popoverContent"
      autoClose="outside"
      container="body"
      popoverClass="find-transactions-popover"
      (shown)="onSearchPopoverShown()"
      (hidden)="onSearchPopoverHidden()"
    >
      Find Transactions
    </button>
    <ng-template #popoverContent>
      <ng-content></ng-content>
    </ng-template>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right class="createbulk">
    <button
      nf-button="cancel"
      [title]="cancelRequestTitle"
      [disabled]="!isLoading"
      (click)="onCancelRequest()"
    >
      Cancel Request
    </button>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right class="clear-filters-button">
    <button
      class="m-0"
      icon="filter-remove"
      nf-icon-button="secondary"
      ngbTooltip="Clear Table"
      placement="bottom-right"
      container="body"
      (click)="clearFilters()"
      [disabled]="data.length === 0"
    >
      Clear Table
    </button>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content
    id="bulk-cw-tx-limit-exceeded-alert"
    *ngIf="transactionsLimitExceeded"
  >
    <ngb-alert [dismissible]="false">
      <strong>Data may be incomplete! </strong> More than {{ maxTransactions }}
      transactions found, please narrow down your search to receive the complete
      list.
    </ngb-alert>
  </nf-grid-wrapper-content>
  <nf-grid-wrapper-content>
    <hs-upload-transactions-file></hs-upload-transactions-file>
    <nf-table-layout
      [hideTitle]="true"
      [isSectionTitle]="true"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [autoResizeGrid]="false"
      [data]="data"
      hideSearch
      hideClearAll
      *nfLoader="isLoading"
    >
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
